<template>
    <!--
    <div class="row">
      <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card card-stats">
          <div class="card-body">
            <div class="row">
              <div class="col-5 col-md-4">
                <div class="icon-big text-center icon-warning">
                  <i class="nc-icon nc-single-02 text-warning"></i>
                </div>
              </div>
              <div class="col-7 col-md-8">
                <div class="numbers">
                  <p class="card-category">Usuarios</p>
                  <p class="card-title">{{ stats.users }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <hr>
            <div class="stats">
              <i class="fa fa-refresh"></i> Actualizado ahora
            </div>
          </div>
        </div>
      </div>
      
      <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card card-stats">
          <div class="card-body">
            <div class="row">
              <div class="col-5 col-md-4">
                <div class="icon-big text-center icon-warning">
                  <i class="nc-icon nc-key-25 text-success"></i>
                </div>
              </div>
              <div class="col-7 col-md-8">
                <div class="numbers">
                  <p class="card-category">Roles</p>
                  <p class="card-title">{{ stats.roles }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <hr>
            <div class="stats">
              <i class="fa fa-calendar-o"></i> Última actualización
            </div>
          </div>
        </div>
      </div>
      
      <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card card-stats">
          <div class="card-body">
            <div class="row">
              <div class="col-5 col-md-4">
                <div class="icon-big text-center icon-warning">
                  <i class="nc-icon nc-vector text-danger"></i>
                </div>
              </div>
              <div class="col-7 col-md-8">
                <div class="numbers">
                  <p class="card-category">Unidades</p>
                  <p class="card-title">{{ stats.unidades }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <hr>
            <div class="stats">
              <i class="fa fa-clock-o"></i> En la última semana
            </div>
          </div>
        </div>
      </div>
      
      <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card card-stats">
          <div class="card-body">
            <div class="row">
              <div class="col-5 col-md-4">
                <div class="icon-big text-center icon-warning">
                  <i class="nc-icon nc-favourite-28 text-primary"></i>
                </div>
              </div>
              <div class="col-7 col-md-8">
                <div class="numbers">
                  <p class="card-category">Áreas</p>
                  <p class="card-title">{{ stats.areas }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <hr>
            <div class="stats">
              <i class="fa fa-refresh"></i> Actualizado ahora
            </div>
          </div>
        </div>
      </div>
    </div>
    -->

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h5 class="card-title">Bienvenido al Sistema Admnistrativo de la DDE-Beni</h5>
            <p class="card-category">Panel de Administración</p>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <img src="/img/escudo-beni.png" alt="Logo" style="width: 100%;">
              </div>
              <div class="col-md-9">
                <h5>Información general</h5>
                <p>Bienvenido al Sistema Administrativo de la Dirección Departamental de Educación del Beni.</p>
                <p>Esta plataforma ha sido desarrollada para centralizar y optimizar la gestión institucional, permitiendo un manejo eficiente, seguro y transparente de los procesos internos.</p>
                <p>El sistema se compone de los siguientes subsistemas principales:</p>
                <p><strong> Sistema de Trámite: </strong>Gestiona el registro, seguimiento y control de documentos y solicitudes institucionales, facilitando la trazabilidad y atención oportuna de trámites.</p>
                <p><strong>Sistema de Almacén: </strong>Administra el inventario de bienes y materiales, controlando entradas, salidas, stock y generando reportes para una gestión transparente de recursos.</p>
                
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <p>Desde el panel principal, los usuarios autorizados pueden administrar roles, permisos y acceder a las funciones correspondientes a sus responsabilidades.</p>
                <p>Para soporte o consultas, comuníquese con el administrador del sistema.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { ref, onMounted } from 'vue';
  import axios from 'axios';
  
  export default {
    setup() {
      const stats = ref({
        users: 0,
        roles: 0,
        unidades: 0,
        areas: 0
      });
      
      const fetchStats = async () => {
        try {
          // Simulamos estadísticas para este ejemplo
          // En una aplicación real, probablemente tendrías un endpoint dedicado
          const [usersResponse, rolesResponse] = await Promise.all([
            axios.get('/users'),
            axios.get('/roles')
          ]);
          
          const users = usersResponse.data.users;
          stats.value.users = users.length;
          stats.value.roles = rolesResponse.data.roles.length;
          
          // Calcular unidades y áreas únicas
          const uniqueUnidades = new Set();
          const uniqueAreas = new Set();
          
          users.forEach(user => {
            if (user.unidad) uniqueUnidades.add(user.unidad);
            if (user.area) uniqueAreas.add(user.area);
          });
          
          stats.value.unidades = uniqueUnidades.size;
          stats.value.areas = uniqueAreas.size;
        } catch (error) {
          console.error('Error al cargar estadísticas:', error);
        }
      };
      
      onMounted(() => {
        fetchStats();
      });
      
      return {
        stats
      };
    }
  };
  </script>